export const deClientPortalCreateOrderPagePages = {
    orders: {
        createOrderPage: {
            title: 'Neuen Auftrag erstellen',
            infoTitle: 'Hinweis',
            missingPermission:
                'Sie haben nicht die Berechtigung einen neuen Auftrag über die einwert Plattform anzulegen, bitte stellen Sie stattdessen eine Anfrage an',
            futureAccess:
                'Falls Sie zukünftig Aufträge über die einwert Plattform anlegen möchten, schalten wir Ihnen das Feature auf Anfrage frei.',
            successMessage: 'Vielen Dank für Ihren Auftrag!',
            successAction: 'Zur Übersicht',
            error: {
                failed: 'Die Auftragsdaten konnten nicht übermittelt werden',
                retry: 'bitte versuchen Sie es erneut.',
                contact: 'Falls der Fehler weiterhin besteht, kontaktieren Sie uns bitte:',
                phone: 'Tel: +49 89 1795 93801',
                email: 'Email: auftrag@einwert.com',
            },
            steps: {
                asset: 'Immobilie anlegen',
                valuation: 'Gutachten beauftragen',
            },
            footer: {
                back: 'Zurück',
                next: 'Weiter',
                cancel: 'Abbrechen',
                submit: 'Jetzt Beauftragen',
            },
            validation: {
                requiredField: 'Pflichtfeld',
            },
            mandator: {
                additionalMandatorsTitle: 'Zusätzliche Auftraggeber',
                additionalMandatorsDisabledTooltip:
                    'Bitte wählen Sie erst oben einen Hauptauftraggeber bevor Sie zusätzliche Auftraggeber hinzufügen.',
                addAdditionalMandatorAriaLabel: 'Zusätzliche Auftraggeber hinzufügen',
                additionalMandatorsQuestion: 'Gibt es zusätzliche Auftraggeber die im Gutachten gelistet werden sollen?',
                mandatorSelect: {
                    inputLabel: 'Auftraggeber auswählen',
                    addNew: 'Neuen Auftraggeber hinzufügen',
                    addModalTitle: 'Auftraggeber hinzufügen',
                    requiredField: 'Pflichtfeld',
                },
                mandatorListItem: {
                    edit: 'Bearbeiten',
                    delete: 'Löschen',
                    editModalTitle: 'Auftraggeber bearbeiten',
                },
                mandatorForm: {
                    name: 'Name',
                    street: 'Straße',
                    houseNumber: 'Hausnummer',
                    zip: 'Postleitzahl',
                    city: 'Stadt',
                    country: 'Land',
                },
                contactForm: {
                    salutation: 'Anrede',
                    salutationOptions: {
                        mr: 'Herr',
                        ms: 'Frau',
                        dr: 'Dr.',
                        mrDr: 'Herr Dr.',
                        msDr: 'Frau Dr.',
                        placeholder: 'Anrede auswählen',
                    },
                    name: 'Vorname und Nachname',
                    role: 'Rolle',
                    company: 'Firma',
                    street: 'Straße',
                    houseNumber: 'Hausnummer',
                    zip: 'Postleitzahl',
                    city: 'Stadt',
                    email: 'E-Mail',
                    invalidEmail: 'Keine gültige E-Mail',
                    phoneNumber: 'Telefonnummer',
                    invalidPhoneNumber: 'Keine gültige Telefonnummer',
                    note: 'Anmerkung / Wann soll diese Person kontaktiert werden?',
                    infoBox:
                        'Alle Felder sind optional, bitte geben Sie nur die persönlichen Informationen an welche für eine Kontakaufnahme nötig sind.',
                },
                contactListItem: {
                    edit: 'Bearbeiten',
                    delete: 'Löschen',
                    editModalTitle: 'Ansprechpartner bearbeiten',
                },
                additionalContactsTitle: 'Zusätzliche Ansprechpartner',
                additionalContactsDescription:
                    'Haben Sie zusätzliche Kontaktdaten von Ansprechpartnern rund um das Gutachten und die Immobilie? Eigentümerdaten könnten beispielsweise hilfreich sein, um einen Besichtigungstermin auszumachen.',
                addContactTitle: 'Ansprechpartner hinzufügen',
                addContactAriaLabel: 'Zusätzliche Ansprechpartner hinzufügen',
                discardUnsavedChanges: 'Sie haben ungespeicherte Änderungen. Möchten Sie die Änderungen wirklich verwerfen und fortfahren?',
            },
            asset: {
                createNew: 'Neue Immobilie erstellen',
                linkExisting: 'Bestehende Immobilie verknüpfen',
                search: 'Immobilie suchen',
                noMatchingAssets: 'Keine passenden Immobilien gefunden',
                noAssetSelected: 'Bitte erstellen oder wählen Sie erst eine Immobilie',
                customerAssetReference: 'Kundeninterne Objekt-ID',
                customerAssetReferenceTooltip:
                    'Optional können Sie für die neue Immobilie Ihre firmeninterne Objekt-ID hinterlegen. Damit können Sie später auf den Übersichtsseiten schneller und einfacher nach bestimmten Immobilien suchen und filtern.',
                addressSearch: {
                    noMatchingAddress: 'Keine passende Adresse gefunden',
                    enterAddressToShowOptions: 'Adresse angeben um Optionen anzuzeigen',
                    consentRequiredLabel: 'Zum Benutzen der Adresssuche müssen Sie Google Maps zulassen',
                    searchLabel: 'Adresse suchen',
                },
                address: {
                    defaultCountry: 'Deutschland',
                    street: 'Straße',
                    houseNumber: 'Hausnummer',
                    state: 'Bundesland',
                    city: 'Stadt',
                    zip: 'PLZ',
                    country: 'Land',
                },
            },
            valuation: {
                valuationDate: 'Wertermittlungsstichtag',
                valuationReason: 'Auftragszweck *',
                assetUsageTypes: 'Nutzungsart / Objektart',
                assetUsageTypesTooltip:
                    'Bitte nennen Sie die Nutzungs- bzw. Objektart aller Objekte die Teil dieser Bewertung sind. Es können mehrere Optionen ausgewählt werden. Sollte die passende Objektart nicht gelistet sein, können Sie auch Freitext eingeben.',
                additionalInformation: 'Zusätzliche Informationen',
                assignees: 'Zuständig',
                additionalContacts: 'Zusätzliche Ansprechpartner',
                objectId: 'Objekt-ID:',
                costCenter: {
                    inputLabel: 'Kostenstelle auswählen',
                    addNewLabel: 'Neue Kostenstelle hinzufügen',
                    form: {
                        name: 'Name Kostenstelle',
                        description: 'Kurzbeschreibung',
                    },
                },
                customerAssignment: {
                    addButton: 'Kund/in hinzufügen',
                    modalTitle: 'Zuständige Kund/innen',
                    cancel: 'Abbrechen',
                    duplicateWarning: 'Dieselbe/r Kund/in wurde mehrfach ausgewählt. Bitte ändern Sie einen der Einträge.',
                    assigneeLabel: 'Zuständige/r Kund/in',
                    removeTooltip: 'Entfernen',
                    addMore: 'Weitere hinzufügen',
                },
                contactForm: {
                    salutation: 'Anrede',
                    salutationOptions: {
                        mr: 'Herr',
                        ms: 'Frau',
                        dr: 'Dr.',
                        mrDr: 'Herr Dr.',
                        msDr: 'Frau Dr.',
                        placeholder: 'Anrede auswählen',
                    },
                    name: 'Vorname und Nachname',
                    role: 'Rolle',
                    company: 'Firma',
                    street: 'Straße',
                    houseNumber: 'Hausnummer',
                    zip: 'Postleitzahl',
                    city: 'Stadt',
                    email: 'E-Mail',
                    invalidEmail: 'Keine gültige E-Mail',
                    phoneNumber: 'Telefonnummer',
                    invalidPhoneNumber: 'Keine gültige Telefonnummer',
                    note: 'Anmerkung / Wann soll diese Person kontaktiert werden?',
                    infoBox:
                        'Alle Felder sind optional, bitte geben Sie nur die persönlichen Informationen an welche für eine Kontakaufnahme nötig sind.',
                },
                contactListItem: {
                    edit: 'Bearbeiten',
                    delete: 'Löschen',
                    editModalTitle: 'Ansprechpartner bearbeiten',
                },
            },
        },
    },
}
